import { render, staticRenderFns } from "./counts.vue?vue&type=template&id=18f8c4fa&scoped=true&"
import script from "./counts.vue?vue&type=script&lang=js&"
export * from "./counts.vue?vue&type=script&lang=js&"
import style0 from "./counts.vue?vue&type=style&index=0&id=18f8c4fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8c4fa",
  null
  
)

export default component.exports